import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // 사업개요
  {
    path: '/business',
    component: () => import('../views/business/BusinessView.vue'),
    redirect: '/business/overview',
    children: [
      {
        path: 'overview',
        name: 'business-overview',
        component: () => import('../views/business/OverViewTab.vue')
      },
      {
        path: 'location-env',
        name: 'business-location-env',
        component: () => import('../views/business/LocationEnvTab.vue')
      },
      {
        path: 'premium',
        name: 'business-premium',
        component: () => import('../views/business/PremiumTab.vue')
      },
      {
        path: 'brand',
        name: 'business-brand',
        component: () => import('../views/business/BrandTab.vue')
      },
      {
        path: 'location',
        name: 'business-location',
        component: () => import('../views/business/LocationTab.vue')
      }
    ]
  },
  // 단지안내
  {
    path: '/complex',
    component: () => import('../views/complex/ComplexView.vue'),
    redirect: '/complex/layout',
    children: [
      {
        path: 'layout',
        name: 'complex-layout',
        component: () => import('../views/complex/LayoutTab.vue')
      },
      {
        path: 'community',
        name: 'complex-community',
        component: () => import('../views/complex/CommunityTab.vue')
      }
    ]
  },
  // 세대안내
  {
    path: '/unit',
    component: () => import('../views/unit/UnitView.vue'),
    redirect: '/unit/type',
    children: [
      {
        path: 'type',
        name: 'unit-type',
        component: () => import('../views/unit/TypeTab.vue')
      }
    ]
  },
  // 고객센터
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/support/SupportView.vue')
  },
  // 관리자 페이지
  {
    path: '/adminlogebien',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.path.startsWith('/business') && from.path.startsWith('/business')) {
      return false
    }
    if (to.path.startsWith('/complex') && from.path.startsWith('/complex')) {
      return false
    }
    if (to.path.startsWith('/unit') && from.path.startsWith('/unit')) {
      return false
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router